/* @sravni/react-design-system version 0.2.71 */
var css = "._bxzzrs {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  width: 100%;\n}\n._1fhy96i {\n  width: 100%;\n  padding: 0 16px;\n  color: var(--color-D30);\n  pointer-events: none;\n  font-size: 12px;\n  line-height: 16px;\n}\n._1fhy96i._1w0cego {\n  color: var(--color-D20);\n}\n._1fhy96i._lc0gve {\n  color: var(--color-R100);\n}\n";
var modules_3ebc0b30 = {"container":"_bxzzrs","helperText":"_1fhy96i","disabled":"_1w0cego","invalid":"_lc0gve"};
import "../../../assets/components/FormControl/src/FormControl-e84769af.css";

export default modules_3ebc0b30;
export { css };
